module.exports = "/assets/975083217494a9bb66dfdbba332080eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BW.png
// module id = 2374
// module chunks = 0